import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../fichierCss/AccesRefusePilotage.css';

const AccesRefuseConnexion = () => {
  const location = useLocation();
  const depuis = location?.state?.depuis || '/';

  return (
    <section className="acces-refuse-pilotage-page">
      <div className="acces-refuse-pilotage-card">
        <p className="acces-refuse-kicker">Connexion requise</p>
        <h1>Acces refuse, veuillez vous authentifier.</h1>
        <p>Acces refuse, veuillez vous authentifier.</p>

        <div className="acces-refuse-actions">
          <Link to="/" className="acces-refuse-btn secondaire">Retour a l'accueil</Link>
          <Link to={depuis} className="acces-refuse-btn primaire">Revenir a la page precedente</Link>
        </div>
      </div>
    </section>
  );
};

export default AccesRefuseConnexion;